import React from 'react'
import { NextImage } from '@/components/NextImage'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useTranslation } from '@/localization/useTranslation'
import { IGlobalProps, IScene } from '@/types/cinematics'

import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import classNames from 'classnames'
import classes from './styles.module.scss'
import { useGeolocation } from '@/hooks/geolocation/useGeolocation'

interface FiltersProps {
  globalFilterProps?: IGlobalProps['filters']
  setFilterProps?: IScene['set']['filters']
}

export const Filters: React.FC<FiltersProps> = (props) => {
  const { globalFilterProps, setFilterProps } = props
  const pathname = usePathname()
  const { t } = useTranslation()
  const isHome = pathname === '/'

  const { checkGeolocation } = useGeolocation()

  if (!setFilterProps?.hasFilters && !globalFilterProps?.items?.length) return null

  const filterItems = globalFilterProps?.items.filter((item) => {
    const isAllowed = checkGeolocation({
      allow: item?.geolocation?.allow || [],
      deny: item?.geolocation?.deny || [],
    })

    return isAllowed
  })

  if (!filterItems?.length) return null

  return (
    <div className={classNames({
      [classes.container]: true,
    })}>
      <div className={classes.filters}>
        {filterItems?.map((item) => {
          const isActive = pathname === item.path
          const displayHomeReturnIcon = item.path === '/' && !isHome

          return (
            <Link
              className={classNames({
                [classes.filter]: true,
                [classes['filter--active']]: isActive,
                [classes['filter--home']]: displayHomeReturnIcon
              })}
              key={item.path}
              href={item.path}
            >
              {item.image &&
                <NextImage
                  src={item.image}
                  alt={t(item.name)}
                  width={24}
                  height={24}
                />
              }
              <div className={classes.filter__name}>
                {displayHomeReturnIcon ?
                  <FontAwesomeIcon icon={faClose} /> :
                  t(item.name)
                }
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
